export default "__VITE_ASSET__fa0LpX2b__"